<template>
  <div class="dash invite">
    <div class="dash-section">
      <div class="main-wrapper">
        <div class="main-content">
          <div class="header">
            <div class="header-top">
              <div class="logo-wrapper">
                <img class="logo" src="../assets/img/logo_white.png" alt="Mashup logo">
              </div>
              <a class="a-icon" href.prevent v-if="this.$route.name != 'legal'">
                <vs-avatar color="#f9f9f9" size="42px" :src="require('../assets/img/ico-man.svg')"/>
                <p class="user-name">{{name || $t('dash.header.myaccount')}}</p>
              </a>
              <div class="language-wrapper">
                <vs-dropdown vs-custom-content vs-trigger-click color="#B20564">
                  <a class="a-icon" href.prevent>
                    <p class="locale">{{ this.$i18n.locale }}</p>
                    <i class="material-icons">keyboard_arrow_down</i>
                  </a>
                  <vs-dropdown-menu class="select-lang">
                    <vs-dropdown-item v-for="lang in locales" :key="lang" :class="lang" @click="changeLocale(lang)">
                      <p>{{ lang }}</p>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
            </div>
          </div>
          <div class="section">
            <router-view
              v-on:nameAccount="nameAccount"
            ></router-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'invite',

  data() {
    return {
      locales: ['en', 'fr', 'de', 'es', 'pt', 'it'],
      name: this.$t('dash.header.myaccount')
    }
  },

  methods: {
    nameAccount(name) {
      this.name = name
    },

    changeLocale(lang) {
      localStorage.setItem('language', lang)
      this.$i18n.locale = lang
    },
  },

  created() {
    
  },

  mounted() {
    document.body.classList.add('dash');
  },

}
</script>
